/* unplugin-vue-components disabled */import script from "./CourseDesignDetailRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseDesignDetailRight.vue?vue&type=script&setup=true&lang=ts"

import "./CourseDesignDetailRight.vue?vue&type=style&index=0&id=63caf77e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63caf77e"]])

export default __exports__